import React from 'react'
import './contact.css'

import { IoLocationOutline } from "react-icons/io5";
import { AiOutlineMail } from "react-icons/ai";
import { IoCallOutline } from "react-icons/io5";
import { SlSocialFacebook } from "react-icons/sl";
import { SlSocialInstagram } from "react-icons/sl";
import { SlSocialTwitter } from "react-icons/sl";
import { SlSocialYoutube } from "react-icons/sl";

const Contact = () => {
  return (
    <section className="section contact" id="contact" allowFullScreen="true">
        <article className="contact__data">
            <h1>Get in Touch</h1>
        </article>

        <article className="contact__box">
            <div className="contact__form box">
              <h3>Send a Massage</h3>
              <form>
                <div className="form__box">
                  
                  <div className="row50">
                    <div className="form__input">
                      <span>First Name</span>
                      <input type="text" placeholder='John' />
                    </div>

                    <div className="form__input">
                      <span>Last Name</span>
                      <input type="text" placeholder='Doe' />
                    </div>
                  </div>

                  <div className="row50">
                    <div className="form__input">
                      <span>Email</span>
                      <input type="text" placeholder='jhondoe@gmail.com' />
                    </div>

                    <div className="form__input">
                      <span>Mobile</span>
                      <input type="text" placeholder='+62 856 789 123' />
                    </div>
                  </div>

                  <div className="row100">
                    <div className="form__input">
                      <span>Message</span>
                      <textarea name="text" placeholder='Write your message here'></textarea>
                    </div>
                  </div>

                  <div className="row100">
                    <div className="form__input">
                      <input type="submit" value="Send" className='input__btn'/>
                    </div>
                  </div>

                </div>
              </form>
            </div>


            <div className="contact__info box">
              <h3>Contact Info</h3>

              <div className="info__data">
                
                <div>
                  <span><IoLocationOutline /></span>
                  <p>Bandung district, Indonesia</p>
                </div>

                <div>
                  <span><AiOutlineMail /></span>
                  <a href="mailto:loremipsum@gmail.com">loremipsum@gmail.com</a>
                </div>

                <div>
                  <span><IoCallOutline /></span>
                  <a href="tel:+62856789123">+62 856 789 123</a>
                </div>
                
                <ul className='social__media'>
                  <li><a href="#" aria-hidden="true"><SlSocialFacebook /></a></li>
                  <li><a href="#" aria-hidden="true"><SlSocialInstagram /></a></li>
                  <li><a href="#" aria-hidden="true"><SlSocialTwitter /></a></li>
                  <li><a href="#" aria-hidden="true"><SlSocialYoutube /></a></li>
                </ul>

              </div>
            </div>


            <div className="contact__map box">
            <iframe allowFullScreen src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d253497.1393726255!2d107.47834459527094!3d-6.903421164625082!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e68e6398252477f%3A0x146a1f93d3e815b2!2sBandung%2C%20Kota%20Bandung%2C%20Jawa%20Barat!5e0!3m2!1sid!2sid!4v1702189648502!5m2!1sid!2sid"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title='Bandung'></iframe>
            </div>
        </article>
    </section>
  )
}

export default Contact